import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import API_URL from "../../localhost/config"; //Importa la variable global

function ResultadoFecha() {
  const { idTorneo, idFecha } = useParams();
  const [detallesFecha, setDetallesFecha] = useState(null);

  useEffect(() => {
    const obtenerDetallesFecha = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/getDetallesFecha?idFecha=${idFecha}`
        );
        setDetallesFecha(response.data);
      } catch (error) {
        console.error(
          "Error al obtener los detalles de la fecha:",
          error.response?.data?.message || error.message
        );
      }
    };

    obtenerDetallesFecha();
  }, [idFecha]);

  if (!detallesFecha) {
    return <p>Cargando resultados...</p>;
  }

  return (
    <div>
      <h2>Detalles de la Fecha</h2>
      <p>ID del Torneo: {idTorneo}</p>
      <p>ID de la Fecha: {idFecha}</p>
      {/* Muestra otros detalles de la fecha según tu estructura de datos */}
      {/* Por ejemplo: <p>Fecha: {detallesFecha.fecha}</p> */}
    </div>
  );
}

export default ResultadoFecha;
